export function canCancelConsent(employee) {
  return !employee || employee.get('canWithdrawPBB')
}
